<section class="start">
  <header class="start-head">
    <span class="logo" aria-hidden="true">
      <span></span><span class="on"></span><span></span><span class="on"></span>
      <span class="on"></span><span></span><span class="on"></span><span></span>
    </span>
    <h1 class="wordmark">LED Board</h1>
  </header>

  <div class="preview" [class.empty]="!livePreview">
    <img *ngIf="livePreview" class="preview-img" [src]="livePreview" alt="What the board is showing right now" />
    <p *ngIf="!livePreview" class="preview-empty">The board is dark. Yours could be the one that lights it up.</p>
    <span class="live-chip" *ngIf="livePreview">
      <span class="dot" aria-hidden="true"></span>{{ liveAnimated ? 'Playing now' : 'On the board now' }}
    </span>
  </div>

  <button type="button" class="jam-banner" *ngIf="sessionsEnabled && sessionLive" (click)="join.emit()">
    <span class="dot" aria-hidden="true"></span>
    <span class="jam-text">
      <span class="jam-title">{{ sessionPeopleText }}</span>
      <span class="jam-sub">{{ sessionCountdown }} left &middot; tap to draw with them</span>
    </span>
    <span class="chev" aria-hidden="true">›</span>
  </button>

  <div class="pitch">
    <h2>Put your art on the board</h2>
    <p>Pick a way to start. It'll light up on the board in front of you.</p>
  </div>

  <div class="choices">
    <button type="button" class="choice primary" (click)="draw.emit()">
      <span class="ic" aria-hidden="true">✏️</span>
      <span class="text">
        <span class="title">Draw it</span>
        <span class="sub">Tap squares to paint</span>
      </span>
      <span class="chev" aria-hidden="true">›</span>
    </button>

    <button type="button" class="choice live" (click)="session.emit()" *ngIf="sessionsEnabled && !sessionLive">
      <span class="ic" aria-hidden="true">🔴</span>
      <span class="text">
        <span class="title">Start a live session</span>
        <span class="sub">Draw together, anyone can join</span>
      </span>
      <span class="chev" aria-hidden="true">›</span>
    </button>

    <button type="button" class="choice" (click)="photo.emit()">
      <span class="ic" aria-hidden="true">📷</span>
      <span class="text">
        <span class="title">Use a photo</span>
        <span class="sub">Turn a photo into pixels</span>
      </span>
      <span class="chev" aria-hidden="true">›</span>
    </button>

    <button type="button" class="choice" (click)="gallery.emit()">
      <span class="ic" aria-hidden="true">🖼️</span>
      <span class="text">
        <span class="title">Pick a design</span>
        <span class="sub">{{ galleryHint }}</span>
      </span>
      <span class="thumbs" *ngIf="previewThumbs.length; else chevron">
        <img *ngFor="let d of previewThumbs; trackBy: trackByDesign" [src]="d.thumbnail" [alt]="d.name" />
      </span>
      <ng-template #chevron><span class="chev" aria-hidden="true">›</span></ng-template>
    </button>
  </div>
</section>
